import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { SectionBannersService } from './section-banners.service';

export interface BazaarPriceInput {
  start_price: number;
  end_price: number;
}
export interface BazaarPriceRecord {
  id: number | string;
  start_price: number | string;
  end_price: number | string;
}

@Injectable({ providedIn: 'root' })
export class BazaarSettingsService extends SectionBannersService {
  constructor(http: HttpClient, @Inject('API_URL') url: string, @Inject('API_VERSION') version: string) {
    super(http, url, version, { routePrefix: 'bazaar', featureEntity: 'bazaar', orderKey: 'bazaar_banners', label: 'Bazaar' });
  }

  getPriceRange(): Observable<{ records: BazaarPriceRecord[] }> {
    return this.request<{ records: BazaarPriceRecord[] }>('GET', 'bazaar-price-range/admin/price').pipe(
      catchError((error: unknown) => {
        // Older deployments expose only /price. Keep the admin route first so
        // newer backends can read settings even when the Bazaar storefront is disabled.
        if (error instanceof HttpErrorResponse && error.status === 404 && error.error?.message === 'Route Not Found') {
          return this.request<{ records: BazaarPriceRecord[] }>('GET', 'bazaar-price-range/price');
        }
        return throwError(() => error);
      })
    );
  }

  savePriceRange(input: BazaarPriceInput, id: number | null): Observable<BazaarPriceRecord> {
    return this.request(id === null ? 'POST' : 'PUT', `bazaar-price-range/price${id === null ? '' : `/${id}`}`, input);
  }
}
